import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {config} from '../../shared/smartadmin.config';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {DEVAPI_BUILD, PRODUCTION_BUILD, SYSTEM_NAME} from '../../+app-custom/app.settings';

@Injectable()
export class JsonApiService {

    constructor(private http: Http) {
    }

    public fetch(url): Observable<any> {
        return this.http.get(this.getBaseUrl() + config.API_URL + url)
            .delay(100)
            .map(this.extractData)
            .catch(this.handleError)
    }

    private getBaseUrl(withoutSystemName = false) {
        return PRODUCTION_BUILD || DEVAPI_BUILD
            ? `${location.protocol}//${location.hostname}${
                location.port ? `:${location.port}` : ''
            }/`
            : `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/`;
    }

    private extractData(res: Response) {
        const body = res.json();
        if (body) {
            return body.data || body
        } else {
            return {}
        }
    }

    private handleError(error: any) {
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/api/json-api.service.ts